import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { AppConfigManager } from "@/features/admin/components/app-config-manager";
import { PageContainer } from "@fleet/ui/page-container";

function AdminConfigPage() {
  return (
    <PageContainer maxWidth="4xl">
      <AppConfigManager />
    </PageContainer>
  );
}

export const adminConfigRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/config",
  component: AdminConfigPage,
});
